import { render, staticRenderFns } from "./LearnerMarksheetIcscAnnualPrint.vue?vue&type=template&id=2dff1315&scoped=true&style=background-color%3A%20white%3B&"
import script from "./LearnerMarksheetIcscAnnualPrint.vue?vue&type=script&lang=js&"
export * from "./LearnerMarksheetIcscAnnualPrint.vue?vue&type=script&lang=js&"
import style0 from "./LearnerMarksheetIcscAnnualPrint.vue?vue&type=style&index=0&id=2dff1315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff1315",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
